module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-addons flatpickr form-horizontal row clearfix",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    staticClass: "input form-control",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "data-input": "",
      "data-toggle": ""
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('a', {
    staticClass: "input-button",
    attrs: {
      "title": _vm.clearTooltip,
      "data-clear": ""
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove"
  })])]), _vm._v(" "), _vm._t("default")], 2)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-866fe894!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/banet-datetime-picker/plugins/VueBulmaDatepicker/WrapperInput.vue
// module id = 696
// module chunks = 0